import { createContext } from 'react';

//Types
import { UserContextType } from "@/@types/context/UserContext";

const UserContext = createContext<UserContextType | null>(null);
UserContext.displayName = 'UserContext';

export default UserContext
